import { z } from 'zod';
import { EventListItemDto } from './event';
import { NewsDto } from './news';
import { PlaceListItemDto } from './place';
import { ServiceListItemDto } from './service';

// События (kind=EVENT) и встречи (kind=MEETING) лежат в одном массиве `events`
// и разделяются на фронте по полю `EventListItemDto.kind`. Это сохраняет
// симметрию с остальной частью API (events.service.ts всегда возвращает
// общий список Event без kind-фильтра).
export const MyFavoritesLikedDto = z.object({
  events: z.array(EventListItemDto),
  news: z.array(NewsDto),
  places: z.array(PlaceListItemDto),
  services: z.array(ServiceListItemDto),
});
export type MyFavoritesLikedDto = z.infer<typeof MyFavoritesLikedDto>;

// `events` — upcoming (organizerUserId=me, не закончились), `pastEvents` —
// прошедшие мои. Разнесены отдельно, чтобы фронт мог показать их разными
// секциями без пере-фильтрации в браузере и без хака с одним массивом+датой.
//
// Места намеренно НЕ включены в «Создано мной»: у Place нет `organizerUserId`,
// только `createdById`, который у админских импортов = сам админ, и тогда
// в «Создано мной» лезла бы вся очередь импорта. Места доступны через
// `liked.places` (лайкнутые) — этого достаточно.
export const MyFavoritesCreatedDto = z.object({
  events: z.array(EventListItemDto),
  pastEvents: z.array(EventListItemDto),
});
export type MyFavoritesCreatedDto = z.infer<typeof MyFavoritesCreatedDto>;

export const MyFavoritesResponseDto = z.object({
  totalCount: z.number().int(),
  // `liked` — только АКТУАЛЬНЫЕ лайки (события не прошли по дате; новости/места
  // лайкнуты не позже 3 дней назад). `likedExpired` — прошедшие/устаревшие той
  // же формы. Счётчик на сердечке (totalCount) учитывает только актуальные.
  // Срок «3 дня» для объектов без даты (новости, места) считается от момента
  // добавления в избранное (createdAt лайка). См. MeFavoritesService (issue #95).
  liked: MyFavoritesLikedDto,
  likedExpired: MyFavoritesLikedDto,
  created: MyFavoritesCreatedDto,
});
export type MyFavoritesResponseDto = z.infer<typeof MyFavoritesResponseDto>;
